export default "__VITE_ASSET__DgnlTjAL__"